import {
  dvtSearchColumns,
  khoHangSearchColumns,
  loaiVatTuSearchColumns,
  nhomColumns,
  phiSearchColumns,
  thuChiSearchColumns,
  thueSearchColumns,
  viTriSearchColumns
} from '@/constants';
import { DonViTinh, Group, GroupType, KhoHang, type LoaiVatTu, type Phi, Tax, type ThuChi } from '@/types/schemas';
import { cachTinhGiaTonKhoOptions } from '../../../cols-definition';
import { FormFieldActions, FormFieldState } from '../../../hooks';
import { FormField, SearchField } from '@/components/custom/erp';
import { ViTriKho } from '@/types/schemas/vi-tri-kho.type';
import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';
import Link from '@/platform/compat/link';

interface Props {
  formMode: 'add' | 'edit' | 'view';
  state: FormFieldState;
  actions: FormFieldActions;
}

export const GeneralTab = ({ formMode, state, actions }: Props) => {
  const isViewMode = formMode === 'view';

  return (
    <>
      <div className='space-y-2 p-4'>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Đơn vị tính</Label>
          <SearchField<DonViTinh>
            displayRelatedField='ten_dvt'
            columnDisplay='dvt'
            searchEndpoint={`/${QUERY_KEYS.DON_VI_TINH}`}
            searchColumns={dvtSearchColumns}
            dialogTitle='Danh mục đơn vị tính'
            value={state.donViTinh?.dvt || ''}
            relatedFieldValue={state.donViTinh?.ten_dvt || ''}
            onRowSelection={actions.setdonViTinh}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Đơn vị tính nhập liệu</Label>
          <SearchField<DonViTinh>
            displayRelatedField='ten_dvt'
            columnDisplay='dvt'
            searchEndpoint={`/${QUERY_KEYS.DON_VI_TINH}`}
            searchColumns={dvtSearchColumns}
            dialogTitle='Danh mục đơn vị tính'
            value={state.donViTinhNhapLieu?.dvt || ''}
            relatedFieldValue={state.donViTinhNhapLieu?.ten_dvt || ''}
            onRowSelection={actions.setdonViTinhNhapLieu}
            disabled={isViewMode}
            className='w-100'
          />
        </div>

        <div className='flex items-center gap-x-2'>
          <div className='flex items-center'>
            <Label className='mt-3 min-w-40 font-medium'>Cách tính giá tồn kho</Label>
            <FormField
              name='gia_ton'
              type='select'
              options={cachTinhGiaTonKhoOptions}
              className='min-w-48'
              disabled={isViewMode}
            />
          </div>
          <Link className='text-sm text-blue-700 hover:text-blue-900 hover:underline' href='#' prefetch={false}>
            (Khai báo trên đơn vị)
          </Link>
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Loại vật tư</Label>
          <SearchField<LoaiVatTu>
            displayRelatedField='ten_lvt'
            columnDisplay='ma_lvt'
            searchEndpoint={`/${QUERY_KEYS.LOAI_VAT_TU}`}
            searchColumns={loaiVatTuSearchColumns}
            dialogTitle='Danh mục loại vật tư'
            value={state.loaiVatTu?.ma_lvt || ''}
            relatedFieldValue={state.loaiVatTu?.ten_lvt || ''}
            onRowSelection={(row: LoaiVatTu) => {
              actions.setloaiVatTu(row);
              actions.setTkKho(row.tk_vt_data);
              actions.setTkDoanhThu(row.tk_dt_data);
              actions.setTkGiaVon(row.tk_gv_data);
              actions.setTkChietKhau(row.tk_ck_data);
              actions.setTkKhuyenMai(row.tk_km_data);
              actions.setTkTraLai(row.tk_tl_data);
              actions.setTkSPDD(row.tk_spdd_data);
              actions.setTkCPNVL(row.tk_cpnvl_data);
            }}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Nhóm 1</Label>
          <SearchField<Group>
            displayRelatedField='ten_phan_nhom'
            columnDisplay='ma_nhom'
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=${GroupType.MATERIAL1}`}
            searchColumns={nhomColumns}
            dialogTitle='Danh mục nhóm vật tư'
            value={state.nhom1?.ma_nhom || ''}
            relatedFieldValue={state.nhom1?.ten_phan_nhom || ''}
            onRowSelection={actions.setnhom1}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Nhóm 2</Label>
          <SearchField<Group>
            displayRelatedField='ten_phan_nhom'
            columnDisplay='ma_nhom'
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=${GroupType.MATERIAL2}`}
            searchColumns={nhomColumns}
            dialogTitle='Danh mục nhóm vật tư'
            value={state.nhom2?.ma_nhom || ''}
            relatedFieldValue={state.nhom2?.ten_phan_nhom || ''}
            onRowSelection={actions.setnhom2}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Nhóm 3</Label>
          <SearchField<Group>
            displayRelatedField='ten_phan_nhom'
            columnDisplay='ma_nhom'
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=${GroupType.MATERIAL3}`}
            searchColumns={nhomColumns}
            dialogTitle='Danh mục nhóm vật tư'
            value={state.nhom3?.ma_nhom || ''}
            relatedFieldValue={state.nhom3?.ten_phan_nhom || ''}
            onRowSelection={actions.setnhom3}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Mã kho mặc định</Label>
          <SearchField<KhoHang>
            displayRelatedField='ten_kho'
            columnDisplay='ma_kho'
            searchEndpoint={`/${QUERY_KEYS.KHO_HANG}`}
            searchColumns={khoHangSearchColumns}
            dialogTitle='Danh mục kho'
            value={state.khoMacDinh?.ma_kho || ''}
            relatedFieldValue={state.khoMacDinh?.ten_kho || ''}
            onRowSelection={actions.setkhoMacDinh}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Vị trí mặc định</Label>
          <SearchField<ViTriKho>
            displayRelatedField='ten_vi_tri'
            columnDisplay='ma_vi_tri'
            searchEndpoint={`/${QUERY_KEYS.VI_TRI_KHO_HANG}`}
            searchColumns={viTriSearchColumns}
            dialogTitle='Danh mục vị trí'
            value={state.viTri?.ma_vi_tri || ''}
            relatedFieldValue={state.viTri?.ten_vi_tri || ''}
            onRowSelection={actions.setviTri}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Mã thuế mặc định</Label>
          <SearchField<Tax>
            displayRelatedField='ten_thue'
            columnDisplay='ma_thue'
            searchEndpoint={`/${QUERY_KEYS.THUE}`}
            searchColumns={thueSearchColumns}
            dialogTitle='Danh mục thuế'
            value={state.thueMacDinh?.ma_thue || ''}
            relatedFieldValue={state.thueMacDinh?.ten_thue || ''}
            onRowSelection={actions.setthueMacDinh}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Mã phí</Label>
          <SearchField<Phi>
            displayRelatedField='ten_phi'
            columnDisplay='ma_phi'
            searchEndpoint={`/${QUERY_KEYS.PHI}`}
            searchColumns={phiSearchColumns}
            dialogTitle='Danh mục phí'
            value={state.phi?.ma_phi || ''}
            relatedFieldValue={state.phi?.ten_phi || ''}
            onRowSelection={actions.setphi}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
        <div className='flex items-center'>
          <Label className='mt-3 min-w-40 font-medium'>Mã thu chi</Label>
          <SearchField<ThuChi>
            displayRelatedField='ten_thu_chi'
            columnDisplay='ma_thu_chi'
            searchEndpoint={`/${QUERY_KEYS.THU_CHI}`}
            searchColumns={thuChiSearchColumns}
            dialogTitle='Danh mục thu chi'
            value={state.thuChi?.ma_thu_chi || ''}
            relatedFieldValue={state.thuChi?.ten_thu_chi || ''}
            onRowSelection={actions.setthuChi}
            disabled={isViewMode}
            className='w-100'
          />
        </div>
      </div>
    </>
  );
};
